import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import Dialog from 'material-ui/Dialog';
import { change, Field, reduxForm, reset } from 'redux-form';
import SmallLoader from '../../../../../img/small-loader.gif'
// import {renderAutoCompleteScheduling } from '../../../../../components/reduxFields';
import { getMasterData, downloadClientList , getDomainBasedOnClient ,getProgramList, getPatientsList} from './actions/downloadClientListActions';
import { CommonButton } from '../../../../../components/buttons';
import { FlatButton } from 'material-ui';
import { delay } from 'lodash';
import MaterialSelectField from 'mui-selectfield-search';

const displayCommaSeperatedList = (items) => {
  let firstElements = '';
  let secondElements = '';
  for (let i = 0; i < items.length; i++) {
    if (items.length === 1) {
      return (<div> {items[0].label}</div>);
    } else {
      for (let j = 0; j < items.length - 1; j++) {
        firstElements = `${items[j].label}, `;
        secondElements = secondElements + firstElements;
      }
      return (<div>{`${secondElements}${items[items.length - 1].label}`}</div>);
    }

  }
};


export const renderAutoCompleteScheduling = ({
  input,
  label,
  value,
  meta: { touched, error },
  handleUpdateInput,
  handleNewRequest,
  options,
  className,
  disabled,
  selected,
  selectedTab,
  lableNameOnNoSlection,
  ...custom
}) => {


let optionsList = [];
let defaultSelected = [];

if (Array.isArray(options) && options.length > 0) {
  const selectedValues = (input.value || []).map((val) =>
    typeof val === 'object' ? val.value : val
  );

  optionsList = options.map(({ id, value }) => {
    if (selectedValues.includes(id)) {
      defaultSelected.push({ label: value, value: id });
    }

    return (
      <div key={id} value={id} label={value}>
        {value}
      </div>
    );
  });
}



 

  const handleOnChange = (selectedValue, name, val) => {
    let selectedPatientData = [];
    let values = [];
    selectedValue.forEach((allValues, i) => {
      values.push(allValues.value);
    });
    
    options.filter((op) => {
      selectedValue.map((selected) => {
        if (selected.value === op.id) {
          selectedPatientData.push(op);
        }
        return selectedPatientData;
      });
      return selectedPatientData;
    });
    handleNewRequest(input, values, null, label, selectedPatientData);
  };

   const handleCustomDisplaySelections1 = (items) => {
       
    return (
      <div>
        <div>
          {(items.length && (items.length > 3)) ?
            <div>
              {items.length === options.length ?    
                <div> All Selected</div> :
                <div> {items.length} {label} Selected </div>
              }
            </div>
            :
            <div>
              {items.length > 0 && items.length <= 3 ?
                displayCommaSeperatedList(items) :
                // <div>No {(label || '').toLowerCase()} selected</div>
                <div>{lableNameOnNoSlection}</div>
              }
            </div>
          }
        </div>
      </div>
    );
  };

const handleCustomDisplaySelections2 = (items) => {

    let element = '';
    
    if(items.length > 0 && items.length <= 3){
        element = displayCommaSeperatedList(items);
    }else{
        if(!lableNameOnNoSlection){
            element = <div>No {(label || '').toLowerCase()} selected</div>
        }else {
            element = <div>{lableNameOnNoSlection} <spna style={{color:'red'}}>*</spna></div>;
        }
    }
       
    return (
      <div>
        <div>
          {(items.length && (items.length > 3)) ?
            <div>
              {items.length === options.length ?
                <div> All Selected</div> :
                <div> {items.length} {label} Selected </div>
              }
            </div>
            :
            <div>
                {
                    element
                }
              {/* {items.length > 0 && items.length <= 3 ?
                displayCommaSeperatedList(items) :
                (!lableNameOnNoSlection ? <div>No {(label || '').toLowerCase()} selected</div>:<div>{lableNameOnNoSlection}</div>)
              } */}
            </div>
          }
        </div>
      </div>
    );
  };

  const handleCustomDisplaySelectionsFunc = input.name === 'Client' ? handleCustomDisplaySelections2 : handleCustomDisplaySelections1;

  return (
    <MaterialSelectField
      showAutocompleteThreshold={1}
      disabled={disabled ? disabled : false}
      hintText=''
      multiple={true}
      checkPosition="left"
      errorText={touched && error}
      value={defaultSelected}
      // elementHeight={(label === 'Location') ? 60 : 40}
      autocompleteUnderlineFocusStyle={{ display: 'none' }}
      // onAutoCompleteTyping={makeApicall}
      nb2show={7}
      onChange={(selected, name, val) => handleOnChange(selected, name, val)}
      required={true}
      selectionsRenderer={handleCustomDisplaySelectionsFunc}
      menuCloseButton={<i className="material-icons selectclose">cancel</i>}      
    >
      {optionsList}
    </MaterialSelectField>
  );
};

class DownloadClientListModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: true,
            allClients:[],
            allDomains:[],
            allPrograms:[],
            selectedClients: [],
            selectedDomains: [],
            selectedPrograms: [],
            showValidation: false,
            selectAllClients: false,
            deSelectAllClients: false,
            deSelectAllDomains:false,
            selectAllDomains: false,
            selectAllPrograms:false,
            deselectAllPrograms:false,
            showDomainValidation:false,
            showProgramValidation:false
        };

    }

    componentDidMount() {
        let masterData = { "masterdata": `CLENTSLIST` };
        this.props.getPatientsList(0,this.props.viewTeamClientsOnlyPermission);
            // MASTERRENDERINGPROVIDERINCLUDINGINACTIVE,MASTERPROGRAMS,MASTERDOMAINS,
        this.props.getMasterData(masterData);
    }

    componentDidUpdate(prevProps) {
        if (this.props.masterData !== prevProps.masterData) {
            if (this.props.masterData) {
                this.setState({ allClients: this.props.masterData.clientsLists });
            }
        }

        if (this.props.domainList !== prevProps.domainList) {
            if (this.props.domainList) {
                this.setState({ allDomains: this.props.domainList });
            }
        }

        if (this.props.programList !== prevProps.programList) {
            if (this.props.programList) {
                this.setState({ allPrograms: this.props.programList });
            }
        }
    }

    
   handleReset = () => {

    };

    selectAllClient = () => { //  Check All Targets 
        let selectedClients = this.state.allClients.map(client => client.id)
        this.props.dispatch(change('DownloadClientListModal', 'Client', selectedClients));
        this.setState({ allClients: this.state.allClients, selectAllClients: true, deSelectAllClients: false,deselectAllDomains:false, selectedClients: selectedClients,showDomainValidation:false,showValidation:false }, () => {
            delay(()=>this.props.getDomainBasedOnClient(this.state.selectedClients),200)
        })
       
    };
    

    selectAllDomains = () => { //  Check All Targets 
        let selectedDomains = this.state.allDomains.map(client => client.id)
        this.props.dispatch(change('DownloadClientListModal', 'domains', selectedDomains));
        this.setState({ allDomains: [...this.state.allDomains], selectAllDomains: true, deSelectAllDomains: false,deselectAllPrograms:false, selectedDomains: selectedDomains ,showDomainValidation:false,showValidation:false}, () => {
            delay(()=>this.props.getProgramList(this.state.selectedClients,this.state.selectedDomains),200)
        });
        
    };

    selectAllPrograms = () => { //  Check All Targets 
        let selectedPrograms = this.state.allPrograms.map(client => client.id)
        this.props.dispatch(change('DownloadClientListModal', 'programs', selectedPrograms));
        this.setState({ allPrograms: [...this.state.allPrograms], selectAllPrograms: true, deselectAllPrograms: false, selectedPrograms: selectedPrograms });
    };


    deselectAllClient = () => { //  Uncheck All Targets   
        let selectedClients = [];
        this.props.dispatch(change('DownloadClientListModal', 'Client', []));
        this.props.dispatch(change('DownloadClientListModal', 'domains', []));
        this.props.dispatch(change('DownloadClientListModal', 'programs', []));

        // this.props.dispatch(change('DownloadClientListModal', 'Client', selectedClients));
        this.setState({selectedClients: [] }, () => {
            this.setState({ allClients: [...this.state.allClients], deSelectAllClients: true, selectAllClients: false,selectAllDomains:false,selectAllPrograms:false, selectedClients: [],selectedDomains:[],selectedPrograms:[] },()=>{
                this.props.getDomainBasedOnClient([])
                this.props.getProgramList(this.state.selectedClients,[])
            });

        });
        
    };

    deselectAllDomains = () => {
        let selectedDomains = [];
        this.props.dispatch(change('DownloadClientListModal', 'domains', []));
        this.props.dispatch(change('DownloadClientListModal', 'programs', []));
        // this.props.dispatch(change('DownloadClientListModal', 'domains', selectedDomains));
        this.setState({}, () => {
            this.setState({
                allDomains: [{ deselectAll: true }, ...this.state.allDomains],
                deSelectAllDomains: true,
                selectAllDomains: false,
                selectAllPrograms:false,
                selectedDomains: [],
                selectedPrograms:[]
            }, () => {
                this.props.getProgramList(this.state.selectedClients, []);
            });
        });
    };

    deselectAllPrograms = () => {
        let selectedPrograms = [];
        this.props.dispatch(change('DownloadClientListModal', 'programs', []));
        this.setState({}, () => {
            this.setState({
                allPrograms: [{ deselectAll: true }, ...this.state.allPrograms],
                deselectAllPrograms: true,
                selectAllPrograms: false,
                selectedPrograms: []
            });
        });
    };

    handleValidation = (name)=>{        
        if(name==="domains" && this.state.selectedClients.length===0){
            this.setState({showValidation:true})
        }
        
        if(name==="programs" && this.state.selectedDomains.length===0){
            this.setState({showDomainValidation:true})
        }
    }


    handleNewRequestMultiSelect = (input, selected, name) => {
        input.onChange(selected)
        if (name === "clientList") this.setState({ selectedClients: selected,showValidation: false},()=>{
            this.props.getDomainBasedOnClient(this.state.selectedClients);
            this.setState({showDomainValidation:false,selectedDomains: []});
            this.props.dispatch(change('DownloadClientListModal', 'domains', []));
            this.props.dispatch(change('DownloadClientListModal', 'programs', []));
        })
        if (name === "domains") this.setState({ selectedDomains: selected },()=>{
            this.props.getProgramList(this.state.selectedClients,this.state.selectedDomains)
            this.setState({showDomainValidation:false,  selectedPrograms: [] });
            this.props.dispatch(change('DownloadClientListModal', 'programs', []));
        })
        if (name === "programs") this.setState({ selectedPrograms: selected })
    }



    handleClose = () => {
        if (this.state.open) {
            this.setState({ open: false });
            this.props.closeDialog();
        }
        this.props.getProgramList([],[])
    };


    handleDownloadClientClick = () => {
        if (this.state.selectedClients.length < 1) {
            this.setState({ showValidation: true })
            return;
        }

        let params = {
            PatientIds:this.state.selectedClients,
            ProgramIds:this.state.selectedPrograms,
            DomainIds:this.state.selectedDomains,
            extension:'xlsx'
        }
        this.props.downloadClientList(params)
        this.handleClose()     
    }

    renderLoading() {
        return (
            <div>
                {this.props.loading ?
                    <div className="full_loader top0">
                        <div className="small-loader">
                            <img src={SmallLoader} alt="" />
                        </div>
                    </div>
                    : null}
            </div>
        );
    }


    render() {
        let claimDetail = null;
        const tableClass = classNames({
            'table': true,
            'table-striped': this.props.condensed,
            'table-bordered': this.props.bordered,
            'table-hover': true,
            'table-condensed': this.props.condensed,
            'customtable': true,
        });
        return (
            <Dialog className="custom_modal_new_appointment"
                title='Download Client List For Targets'
                modal={false}
                open={this.state.open}
                autoScrollBodyContent={true}>
                {this.renderLoading()}

                <form className='readmin-form custom_form'>
                    <div className="row mt-10">
                        
                        <div className="col-sm-6 mt-10">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="sech_item_team">
                                        <span className={this.state.selectAllClients ? 'active' : ''} onClick={this.selectAllClient.bind(this)}>(Select All Clients </span>
                                        <span className={this.state.deSelectAllClients ? 'active' : ''} onClick={this.deselectAllClient.bind(this)}>Deselect All Clients ) </span>
                                    </div>
                                </div>
                                <div className="col-sm-12 require">
                                    <Field
                                        name='Client'
                                        required={true}
                                        lableNameOnNoSlection="Client Name"
                                        options={this.props.patientsList}
                                        handleNewRequest={(input, selected)=>this.handleNewRequestMultiSelect(input, selected,"clientList")}
                                        component={renderAutoCompleteScheduling}
                                    />
                                </div>
                            </div>
                        </div>
                        
                        {this.state.showValidation ?
                            <p style={{ color: "rgb(244, 67, 54)", fontSize: "12px", lineHeight: "12px" }}>
                                Please select Client Name 
                            </p> : null
                        }
                    </div>

                    <div className="row mt-10">
                        {/* <div className="col-6  mt-35"><Field name="Domain" label="Domain(s)" options={this.props.masterData && this.props.masterData.masterDomains} handleNewRequest={(input, slected) => this.handleNewRequest(input, slected, "domains")} component={renderAutoCompleteMultipleSelection} /></div> */}
                        <div className="col-sm-6 mt-10">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="sech_item_team">
                                        <span className={this.state.selectAllDomains ? 'active' : ''} onClick={this.selectAllDomains.bind(this)}>(Select All Domains </span>
                                        <span className={this.state.deSelectAllDomains ? 'active' : ''} onClick={this.deselectAllDomains.bind(this)}>Deselect All Domains ) </span>
                                    </div>
                                </div>
                                <div className="col-sm-12" onClick={()=>this.handleValidation('domains')}>
                                    <Field
                                        name='domains'
                                        lableNameOnNoSlection="Domains"
                                        options={this.props.domainList}
                                        handleNewRequest={(input, selected)=>this.handleNewRequestMultiSelect(input, selected,"domains")}
                                        component={renderAutoCompleteScheduling}
                                    />
                                </div>
                            </div>

                        {this.state.showDomainValidation ?
                            <p style={{ color: "rgb(244, 67, 54)", fontSize: "12px", lineHeight: "12px" }}>
                                Please select Domain
                            </p> : null
                        }
                        </div>
                        {/* <div className="col-6  mt-35"><Field name="Program" label="Program(s)" options={this.props.masterData && this.props.masterData.masterPrograms} handleNewRequest={(input, slected) => this.handleNewRequest(input, slected, "programs")} component={renderAutoCompleteMultipleSelection} /></div> */}
                        <div className="col-sm-6 mt-10">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="sech_item_team">
                                        <span className={this.state.selectAllPrograms ? 'active' : ''} onClick={this.selectAllPrograms.bind(this)}>(Select All Programs </span>
                                        <span className={this.state.deselectAllPrograms ? 'active' : ''} onClick={this.deselectAllPrograms.bind(this)}>Deselect All Programs) </span>
                                    </div>
                                </div>
                                <div className="col-sm-12 "  onClick={()=>this.handleValidation('programs')}>
                                    <Field
                                        name='programs'
                                        lableNameOnNoSlection="Programs"
                                        options={this.props.programList}
                                        handleNewRequest={(input, selected)=>this.handleNewRequestMultiSelect(input, selected,"programs")}
                                        component={renderAutoCompleteScheduling}
                                    />
                                </div>
                            </div>
                        </div>
                        
                    </div>

                    <div className='row'>
                        <div className="col-sm-12 pt20 btn_rt">
                            <FlatButton className="grey_btn" label="Cancel" onTouchTap={this.handleClose} style={{margin:'35px'}}/>
                            <CommonButton primary={true} label="Download Client List" onTouchTap={this.handleDownloadClientClick} />
                        </div>
                    </div>
                </form>

            </Dialog>
        );
    }
}
DownloadClientListModal = reduxForm({
    form: 'DownloadClientListModal',
    enableReinitialize: true
})(DownloadClientListModal);

function mapStateToProps(state) {
    let userScreenPermission = [];
    let userActionPermission = [];
    if (state.login.userPermission) {
      let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'CLIENT');
      userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
      
      let userScreenPermissionEdit = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === 'CLIENT_PROFILE' && obj.moduleId === userModulePermission[0].moduleId);
      userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermissionEdit[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
    }

    let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission

    const domainListSafe = (state.dowload_Clientlist_Reducer.domainList && typeof state.dowload_Clientlist_Reducer.domainList === 'object')
        ? state.dowload_Clientlist_Reducer.domainList.data
        : [];

    const programListSafe = (state.dowload_Clientlist_Reducer.programList && typeof state.dowload_Clientlist_Reducer.programList === 'object')
        ? state.dowload_Clientlist_Reducer.programList.data
        : [];

    let patientsList = [];
    if(state.dowload_Clientlist_Reducer && state.dowload_Clientlist_Reducer.patientsList){
        patientsList = state.dowload_Clientlist_Reducer;
    }  

      let viewTeamClientsOnlyPermission = hasDefaultAccess ? false : userScreenPermission ? userScreenPermission.filter((obj) => obj.screenKey === 'VIEW_TEAM_CLIENTS_ONLY')[0].permission : false;  

    return {
        loading: state.dowload_Clientlist_Reducer.loading,
        masterData: state.dowload_Clientlist_Reducer.masterData,
        domainList: domainListSafe || [],
        programList: programListSafe || [],
        patientsList: state.dowload_Clientlist_Reducer.patientsList,
        viewTeamClientsOnlyPermission: viewTeamClientsOnlyPermission,  
    };
}

export default connect(mapStateToProps, { getMasterData,getPatientsList, downloadClientList,getDomainBasedOnClient,getProgramList})(DownloadClientListModal);



// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/settings/uploadExcel/downLoadClientList/downloadClientListModal.js